import React, { useCallback, useEffect, useState } from "react";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import HeaderPages from "../../../../component/page-components/pages-header";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constant/routeConstant";
import { SubTitleTab, TitleTab } from "../../../../component/page-components";
import { Radio } from "antd";
import DropdownSearchDriver from "../../../../component/dropdown-search/dds-driver";
import style from "./DeliveryAssociate.module.css";
import { useSelector } from "react-redux";
import * as DeliveryAssociateServices from "../../../../service/master/DeliveryAssociateServices";
import DriverProfileOwned from "./add/owned/DriverProfileOwned";
import FormAddressOwned from "./add/owned/FormAddressOwned";
import FleetDetailOwned from "./add/owned/FleetDetailOwned";
import OrderSpekOwned from "./add/owned/OrderSpekOwned";
import DriverProfileOutsource from "./add/outsources/DriverProfileOutsources";
import FormAddressOutsource from "./add/outsources/FormAddressOutsource";
import FleetDetailOutsource from "./add/outsources/FleetDetailOutsource";
import OrderSpekOutsource from "./add/outsources/OrderSpekOutsource";
import NotifFailedSaved from "../../../../component/modal/NotifFailedSaved";
import NotifAddSuccess from "../../../../component/modal/NotifAddSuccess";
import dayjs from "dayjs";
import { validationDA } from "./validationDA";
import { t } from "i18next";

const MainAddDeliveryAssociate = () => {
  const { token } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const location = useLocation();

  const [tab, setTab] = useState(1);
  const [driverType, setDriverType] = useState("owned");
  const [driverID, setDriverID] = useState(null);
  const [detailOwned, setDetailOwned] = useState();

  const [selectedFileList, setSelectedFileList] = useState([]);
  const [selectedFileList2, setSelectedFileList2] = useState([]);

  const [personTitle, setPersonTitle] = useState(null);
  const [maritalSatus, setMaritalStatus] = useState(null);
  const [FormInput, setFormInput] = useState({});
  const [countryId, setCountryId] = useState(null);
  const [provinceId, setProvinceId] = useState(null);
  const [districtId, setDistrictId] = useState(null);
  const [subDistrictId, setSubDistrictId] = useState(null);
  const [urbanVillageId, setUrbanVillageId] = useState(null);
  const [postalCodeId, setPostalCodeId] = useState(null);
  const [valueDayOff, setValueDayOff] = useState();
  const [FormInputShiftStart, setFormInputShiftStart] = useState({});
  const [FormInputShiftEnd, setFormInputShiftEnd] = useState({});
  const [tempCategory, setTempCategory] = useState(null);
  const [skillSet, setSkillSet] = useState(null);
  const [licenseType, setLicenseType] = useState(null);
  const [FormInputDate, setFormInputDate] = useState({});
  const [gender, setGender] = useState(null);

  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messageFailed, setMessageFailed] = useState("");
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [messagesSuccess, setMessagesSuccess] = useState("");

  const [FormError, setFormError] = useState({});

  function handleBack() {
    navigate(ROUTES.DELIVERY_ASSOCIATE.LIST);
  }

  const validateNext = useCallback(() => {
    const datas = {
      ...FormInput,
      ...FormInputDate,
      ...FormInputShiftStart,
      ...FormInputShiftEnd,
      countryId,
      provinceId,
      districtId,
      subDistrictId,
      urbanVillageId,
      postalCodeId,
      valueDayOff,
    };

    const dataCheck = [
      "first_name",
      "nik",
      "phone",
      "email",
      "emergency_contact_name",
      "emergency_contact_no_hp",
      "emergency_contact_address",
      "countryId",
      "provinceId",
      "districtId",
      "subDistrictId",
      "urbanVillageId",
      "address",
      "postalCodeId",
      "shift_start_hour",
      "shift_start_minute",
      "shift_end_hour",
      "shift_end_minute",
      "valueDayOff",
    ];

    function arePropertiesValid(obj, propertyNames) {
      return propertyNames.every((propertyName) =>
        isPropertyValid(obj, propertyName)
      );
    }

    function isPropertyValid(obj, propertyName) {
      return (
        obj.hasOwnProperty(propertyName) &&
        obj[propertyName] !== undefined &&
        obj[propertyName] !== null &&
        obj[propertyName] !== ""
      );
    }

    const isValid = arePropertiesValid(datas, dataCheck);

    return isValid;
  }, [
    FormInput,
    FormInputDate,
    FormInputShiftEnd,
    FormInputShiftStart,
    countryId,
    districtId,
    postalCodeId,
    provinceId,
    subDistrictId,
    urbanVillageId,
    valueDayOff,
  ]);
  const submitOwned = useCallback(async () => {
    const photo = null;

    const formData = new FormData();

    const contents = {
      depot_id: location?.state?.id,
      driver_id: driverID,
      shift_start_time: detailOwned?.shift_start
        ? detailOwned?.shift_start.slice(0, 5)
        : "",
      shift_end_time: detailOwned?.shift_end
        ? detailOwned?.shift_end.slice(0, 5)
        : "",
      daily_salary : Number(detailOwned?.salary),
      hourly_salary:detailOwned?.salary_per_hour
    };
    formData.append("delivery_associate", JSON.stringify(contents));
    formData.append("driver_photo", photo);
    formData.append("license_photo", photo);

    const { status, message } = await DeliveryAssociateServices.insert(
      token,
      null,
      formData
    );
    if (status) {
      setSuccessModalOpen(true);
      setMessagesSuccess(message);
    } else {
      setFailedModalOpen(true);
      setMessageFailed(message);
    }
  }, [
    detailOwned?.shift_end,
    detailOwned?.shift_start,
    detailOwned?.salary,
    detailOwned?.salary_per_hour,
    driverID,
    location?.state?.id,
    token,
  ]);

  const submitOutsources = useCallback(async () => {
    const formData = new FormData();

    const content = {
      depot_id: location?.state?.id,
      title: personTitle,
      first_name: FormInput?.first_name,
      last_name: FormInput?.last_name,
      gender: gender,
      nik: FormInput?.nik,
      birth_place: FormInput?.birth_place,
      date_of_birth: FormInputDate?.date_of_birth
        ? dayjs(FormInputDate?.date_of_birth).format("YYYY-MM-DD")
        : "0001-01-01",
      address: FormInput?.address,
      hamlet: FormInput?.hamlet,
      neighbour: FormInput?.neighbourhood,
      country: countryId,
      province: provinceId,
      district: districtId,
      sub_district: subDistrictId,
      urban_village: urbanVillageId,
      postal_code: postalCodeId,
      phone: FormInput?.phone ? "+62-" + FormInput?.phone : "",
      email: FormInput?.email ? FormInput?.email : "",
      emergency_contact_name: FormInput?.emergency_contact_name,
      emergency_contact_relationship: FormInput?.emergency_contact_relationship,
      emergency_contact_no_hp: FormInput?.emergency_contact_no_hp
        ? "+62-" + FormInput?.emergency_contact_no_hp
        : "",
      emergency_contact_address: FormInput?.emergency_contact_address,
      license_id: 0,
      license_type: licenseType,
      driving_license_no: FormInput?.driving_license_no,
      license_validity: FormInputDate?.license_validity
        ? dayjs(FormInputDate?.license_validity).format("YYYY-MM-DD")
        : "",
      marital_status: maritalSatus ? maritalSatus : null,
      shift_start_time: FormInputShiftStart
        ? FormInputShiftStart?.shift_start_hour +
          ":" +
          FormInputShiftStart?.shift_start_minute
        : "",
      shift_end_time: FormInputShiftEnd
        ? FormInputShiftEnd?.shift_end_hour +
          ":" +
          FormInputShiftEnd?.shift_end_minute
        : "",
      day_off: valueDayOff,
      skill_set: {
        skill_set_id: skillSet ? [skillSet] : null,
      },
      vehicle_ownership: "yes",
      vehicle_type: FormInput?.vehicle_type,
      vehicle_no: FormInput?.vehicle_no,
      vehicle_no_exp_date: FormInputDate?.vehicle_no_exp_date
        ? dayjs(FormInputDate?.vehicle_no_exp_date).format("YYYY-MM-DD")
        : null,
      temperature_category_id: tempCategory,
      model: FormInput?.model,
      max_order_unit: FormInput?.max_order_unit
        ? Number(FormInput?.max_order_unit)
        : null,
      max_order_weight: FormInput?.max_order_weight
        ? Number(FormInput?.max_order_weight)
        : null,
      max_order_volume: FormInput?.max_order_volume
        ? Number(FormInput?.max_order_volume)
        : null,
      min_order_unit: FormInput?.min_order_unit
        ? Number(FormInput?.min_order_unit)
        : null,
      min_order_weight: FormInput?.min_order_weight
        ? Number(FormInput?.min_order_weight)
        : null,
      min_order_volume: FormInput?.min_order_volume
        ? Number(FormInput?.min_order_volume)
        : null,
      fixed_cost: FormInput?.fixed_cost ? Number(FormInput?.fixed_cost) : null,
      variable_cost: FormInput?.variable_cost
        ? Number(FormInput?.variable_cost)
        : null,
      transporter_time_cost: FormInput?.transporter_time_cost
        ? Number(FormInput?.transporter_time_cost)
        : null,
      waiting_time_cost: FormInput?.waiting_time_cost
        ? Number(FormInput?.waiting_time_cost)
        : null,
      daily_salary :FormInput?.daily_salary
      ? Number(FormInput?.daily_salary)
      : null,
      hourly_salary :FormInput?.hourly_salary
      ? Number(FormInput?.hourly_salary)
      : null,
    };

    const driver_photo = selectedFileList
      ? selectedFileList[0]?.originFileObj
      : null;
    const license_photo = selectedFileList2
      ? selectedFileList2[0]?.originFileObj
      : null;

    formData.append("delivery_associate", JSON.stringify(content));
    formData.append("driver_photo", driver_photo);
    formData.append("license_photo", license_photo);
    const { status, message } = await DeliveryAssociateServices.insert(
      token,
      null,
      formData
    );

    if (status) {
      setSuccessModalOpen(true);
      setMessagesSuccess(message);
    } else {
      setFailedModalOpen(true);
      setMessageFailed(message);
    }
  }, [
    FormInput?.address,
    FormInput?.birth_place,
    FormInput?.driving_license_no,
    FormInput?.email,
    FormInput?.emergency_contact_address,
    FormInput?.emergency_contact_name,
    FormInput?.emergency_contact_no_hp,
    FormInput?.emergency_contact_relationship,
    FormInput?.first_name,
    FormInput?.fixed_cost,
    FormInput?.hamlet,
    FormInput?.last_name,
    FormInput?.max_order_unit,
    FormInput?.max_order_volume,
    FormInput?.max_order_weight,
    FormInput?.min_order_unit,
    FormInput?.min_order_volume,
    FormInput?.min_order_weight,
    FormInput?.model,
    FormInput?.neighbourhood,
    FormInput?.nik,
    FormInput?.phone,
    FormInput?.transporter_time_cost,
    FormInput?.variable_cost,
    FormInput?.vehicle_no,
    FormInput?.vehicle_type,
    FormInput?.waiting_time_cost,
    FormInput?.daily_salary,
    FormInput?.hourly_salary,
    FormInputDate?.date_of_birth,
    FormInputDate?.license_validity,
    FormInputDate?.vehicle_no_exp_date,
    FormInputShiftEnd,
    FormInputShiftStart,
    countryId,
    districtId,
    gender,
    licenseType,
    location?.state?.id,
    maritalSatus,
    personTitle,
    postalCodeId,
    provinceId,
    selectedFileList,
    selectedFileList2,
    skillSet,
    subDistrictId,
    tempCategory,
    token,
    urbanVillageId,
    valueDayOff,
  ]);

  const handleBtnNext = useCallback(() => {
    if (tab === 1 && driverID !== null) {
      setTab(2);
      return;
    }
    if (tab === 1 && driverType === "outsource") {
      if (validateNext()) {
        setTab(2);
      }
      return;
    }

    if (tab === 2 && driverType === "owned") {
      submitOwned();
    }

    if (tab === 2 && driverType === "outsource") {
      submitOutsources();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    driverID,
    driverType,
    submitOutsources,
    submitOwned,
    tab,
    selectedFileList,
    selectedFileList2,
  ]);

  const handleBtnPrevious = useCallback(() => {
    if (tab === 2) {
      setTab(1);
      return;
    }
    navigate(ROUTES.DELIVERY_ASSOCIATE.LIST);
  }, [navigate, tab]);

  const onChangeDriverType = useCallback((evt) => {
    setDriverType(evt.target.value);
    setDriverID(null);
    setCountryId(null);
    setProvinceId(null);
    setDistrictId(null);
    setSubDistrictId(null);
    setUrbanVillageId(null);
    setPostalCodeId(null);
    setValueDayOff();
    setFormInput({});
    setFormInputShiftStart({});
    setFormInputShiftEnd({});
  }, []);

  const getDetailDriver = useCallback(
    async (driverId) => {
      const { ok, data } = await DeliveryAssociateServices.detailDriver(
        token,
        driverId
      );
      if (ok && data) {
        const res = await DeliveryAssociateServices.detailVehicle(
          token,
          data?.vehicle_id
        );
        const dataVehicle = res?.data;

        if (res?.ok && dataVehicle) {
          const DataOwned = { ...data, ...dataVehicle };
          setDetailOwned(DataOwned);
        }
        return;
      }
      setDetailOwned();
    },
    [token]
  );

  useEffect(() => {
    if (!driverID || driverID === null) {
      return;
    }
    getDetailDriver(driverID);
    return;
  }, [driverID, getDetailDriver]);

  const handleFormInput = useCallback(
    (val, namespace) => {
      const err = validationDA(namespace, val, t);
      setFormError({
        ...FormError,
        ...err,
      });
      if (namespace === "daily_salary") {
        setFormInput((prevsValue) => {
          return {
            ...prevsValue,
            [namespace]: val,
            ["hourly_salary"]: val / 8,
          };
        });
      }else{
      setFormInput((prevsValue) => ({
        ...prevsValue,
        [namespace]: val,
      }));
    }
    },
    [FormError]
  );

  const handleBlur = useCallback(
  (value, key, isStart)=>{
    // newDetail[i][key] = index === 0 ?(value.length===1 ? "0"+value : value) + ":" + newDetail[i][key].split(":")[1] : newDetail[i][key].split(":")[0] + ":" + (value.length===1 ? "0"+value : value) 
    console.log("value", value);
    if(isStart){
      setFormInputShiftStart((prevsValue) => {
      return {
        ...prevsValue,
        [key]: value ? value?.length===1 ? "0"+value : value : "00"
      };
    });
  }else{
    setFormInputShiftEnd((prevsValue) => {
      return {
        ...prevsValue,
        [key]: value ? value?.length===1 ? "0"+value : value : "00"
      };
    });
  }
  },[]);

  const handleFormInputShiftStart = useCallback(
    (val, namespace) => {
      let data = namespace === "shift_start_hour" ?Number(val) > 23 ? 23 : (val) : Number(val) > 59 ? 59 : (val)
      
      const err = validationDA(namespace, data, t);
      setFormError({
        ...FormError,
        ...err,
      });
      setFormInputShiftStart((prevsValue) => ({
        ...prevsValue,
        [namespace]: data>=0  ? data : "00",
      }));
    },
    [FormError]
  );

  const handleFormInputShiftEnd = useCallback(
    (val, namespace) => {
      let data = namespace === "shift_end_hour" ?Number(val) > 23 ? 23 : (val) : Number(val) > 59 ? 59 : (val)
      
      const err = validationDA(namespace, val, t);
      setFormError({
        ...FormError,
        ...err,
      });
      setFormInputShiftEnd((prevsValue) => ({
        ...prevsValue,
        [namespace]: data>=0  ? data : "00",
      }));
    },
    [FormError]
  );

  const handleFormInputDate = useCallback((val, namespace) => {
    setFormInputDate((prevsValue) => ({
      ...prevsValue,
      [namespace]: val,
    }));
  }, []);

  const handleChangeGender = useCallback((val) => {
    setGender(val);
  }, []);

  const _onOkSuccesAdd = () => {
    setSuccessModalOpen(false);
    navigate(ROUTES.DELIVERY_ASSOCIATE.LIST);
  };

  return (
    <>
      <Breadcumbs
        jmlLevel={3}
        menuLevel1="Master"
        menuLevel2="Fleet"
        menuLevel3="Add Delivery Associate"
      />
      <HeaderPages
        menuType="add"
        title="Add Delivery Associate"
        handleBack={handleBack}
      />
      <div className="container-pages">
        {/* TAB */}
        <div className="container-tabs">
          <div className="w-max flex items-center gap-[16px]">
            <div
              className={`border ${
                tab === 1
                  ? "border-red-100 bg-red-100"
                  : "border-[#228B22] bg-[#228B22]"
              } rounded-full w-[36px] h-[36px] grid place-items-center`}
            >
              <p className="font-sans text-xl font-semibold text-white-100">
                1
              </p>
            </div>
            <p
              className={`font-sans text-xl font-bold ${
                tab === 1 ? "text-red-100" : "text-[#228B22]"
              }`}
            >
              Driver Profile
            </p>
          </div>

          <hr
            className={`border-2 w-[60px] ${
              tab === 1
                ? " border-[#D7D7D7] border-dashed "
                : "border-[#228B22] border-solid"
            } `}
          />

          <div className="w-max flex items-center gap-[16px]">
            <div
              className={`border rounded-full w-[36px] h-[36px] grid place-items-center ${
                tab === 1
                  ? "bg-[#FFFFFF] border-[#FFFFFF]"
                  : "border-red-100 bg-red-100"
              }`}
            >
              <p
                className={`font-sans text-xl font-semibold ${
                  tab === 1 ? "text-[#ACACAC]" : "text-white-100"
                }`}
              >
                2
              </p>
            </div>
            <p
              className={`font-sans text-xl font-bold ${
                tab === 1 ? "text-[#ACACAC]" : "text-red-100"
              }`}
            >
              Fleet Detail
            </p>
          </div>
        </div>

        {/* CONTENT */}
        <div className="flex flex-row gap-6 mt-5 pb-10">
          <div className="basis-1/2">
            {tab === 1 ? (
              <>
                <TitleTab title="Driver Profile" />
                <SubTitleTab title="Driver Type" />
                <Radio.Group
                  className={style.radioBtn}
                  onChange={onChangeDriverType}
                  value={driverType}
                >
                  <Radio
                    value="owned"
                    className=" font-roboto-medium text-[20px]"
                  >
                    Owned
                  </Radio>
                  <Radio
                    value="outsource"
                    className=" font-roboto-medium text-[20px]"
                  >
                    Outsource
                  </Radio>
                </Radio.Group>
              </>
            ) : (
              false
            )}

            {/* Driver Owned */}
            {tab === 1 && driverType === "owned" ? (
              <>
                <SubTitleTab title="Driver" />
                <div className="w-[500px]">
                  <DropdownSearchDriver
                    depotID={location?.state?.id}
                    setValueDDS={setDriverID}
                    valueDDS={driverID}
                  />
                </div>
              </>
            ) : (
              false
            )}
            {tab === 1 && driverID !== null ? (
              <DriverProfileOwned form={detailOwned} />
            ) : (
              false
            )}
            {tab === 2 && driverID !== null ? (
              <FleetDetailOwned form={detailOwned} />
            ) : (
              false
            )}

            {/* Driver Outsorces */}
            {tab === 1 && driverType === "outsource" ? (
              <DriverProfileOutsource
                selectedFileList={selectedFileList}
                setSelectedFileList={setSelectedFileList}
                handleFormInput={handleFormInput}
                FormInput={FormInput}
                personTitle={personTitle}
                setPersonTitle={setPersonTitle}
                maritalSatus={maritalSatus}
                setMaritalStatus={setMaritalStatus}
                handleFormInputDate={handleFormInputDate}
                FormInputDate={FormInputDate}
                handleChangeGender={handleChangeGender}
                gender={gender}
                FormError={FormError}
              />
            ) : (
              false
            )}
            {tab === 2 && driverType === "outsource" ? (
              <FleetDetailOutsource
                setTempCategory={setTempCategory}
                tempCategory={tempCategory}
                depotId={location?.state?.id}
                skillSet={skillSet}
                setSkillSet={setSkillSet}
                setSelectedFileList2={setSelectedFileList2}
                selectedFileList2={selectedFileList2}
                handleFormInput={handleFormInput}
                FormInput={FormInput}
                licenseType={licenseType}
                setLicenseType={setLicenseType}
                handleFormInputDate={handleFormInputDate}
                FormInputDate={FormInputDate}
                FormError={FormError}
              />
            ) : (
              false
            )}
          </div>
          <div className="basis-1/2">
            {/* Driver Owned */}
            {tab === 1 && driverID !== null ? (
              <FormAddressOwned form={detailOwned} />
            ) : (
              false
            )}
            {tab === 2 && driverID !== null ? (
              <OrderSpekOwned form={detailOwned} />
            ) : (
              false
            )}

            {/* Driver Outsorces */}
            {tab === 1 && driverType === "outsource" ? (
              <FormAddressOutsource
                countryId={countryId}
                setCountryId={setCountryId}
                provinceId={provinceId}
                setProvinceId={setProvinceId}
                districtId={districtId}
                setDistrictId={setDistrictId}
                subDistrictId={subDistrictId}
                setSubDistrictId={setSubDistrictId}
                urbanVillageId={urbanVillageId}
                setUrbanVillageId={setUrbanVillageId}
                postalCodeId={postalCodeId}
                setPostalCodeId={setPostalCodeId}
                setValueDayOff={setValueDayOff}
                valueDayOff={valueDayOff}
                handleFormInput={handleFormInput}
                FormInput={FormInput}
                handleFormInputShiftStart={handleFormInputShiftStart}
                FormInputShiftStart={FormInputShiftStart}
                handleFormInputShiftEnd={handleFormInputShiftEnd}
                FormInputShiftEnd={FormInputShiftEnd}
                FormError={FormError}
                handleBlur={handleBlur}
              />
            ) : (
              false
            )}
            {tab === 2 && driverType === "outsource" ? (
              <OrderSpekOutsource
                handleFormInput={handleFormInput}
                FormInput={FormInput}
              />
            ) : (
              false
            )}
          </div>
        </div>
        <NotifFailedSaved
          visible={failedModalOpen}
          message={messageFailed}
          action={() => {
            setFailedModalOpen(false);
          }}
        />
        <NotifAddSuccess
          visible={successModalOpen}
          action={_onOkSuccesAdd}
          menu="Delivery Associate"
        />
      </div>
      <div className="btn-container">
        <button className="btn-cancel" onClick={handleBtnPrevious}>
          {tab === 1 ? "Cancel" : "Previous"}
        </button>
        <button className="btn-next" onClick={handleBtnNext}>
          {tab === 1 ? "Next" : "Add"}
        </button>
      </div>
    </>
  );
};

export default MainAddDeliveryAssociate;
